import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

import { generateReportUrl } from "utils/report.utils";
import { CustomChapterMeta } from "types/custom";
import { RootState } from "redux/reducers";

type MenuItemProps = {
  item: CustomChapterMeta;
  chapter: number;
  searchItems: number[];
};
type ChildLinkProps = {
  readonly selected: boolean;
  readonly highlighted: number;
};

const CustomReportMenuItem: React.FC<MenuItemProps> = ({
  item,
  searchItems,
}) => {
  const { customReport } = useSelector((state: RootState) => state);
  const url = generateReportUrl(customReport.reportData.c_report_name);

  return (
    <ItemContainer key={item.id}>
      <ChildLink
        to={`/custom-reports/${customReport.reportData.c_report_id}/${url}/${item.custom_order}`}
        selected={item.custom_order === customReport.currentChapter}
        highlighted={searchItems.includes(item.custom_order) ? 1 : 0}
      >
        {item.chapter_title}
      </ChildLink>
    </ItemContainer>
  );
};

const ItemContainer = styled.li`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const selectedStyles = () => {
  return css`
    color: ${(props) => props.theme.colors.idataBlue};

    &::before {
      content: "";
      background-color: ${(props) => props.theme.colors.idataBlue};
      border-radius: 50%;
      height: 7px;
      width: 7px;
      position: absolute;
      left: -15px;
      top: 47%;
      transform: translateY(-47%);
    }
  `;
};

const childLinkHandler = (selected: boolean, highlighted: number) => {
  return css`
    color: ${(props) =>
      highlighted === 1
        ? props.theme.colors.yellow
        : props.theme.colors.idataDarkGrey};
    pointer-events: auto;

    &:hover {
      color: ${(props) => props.theme.colors.idataBlue};
    }

    ${selected ? selectedStyles : null}
  `;
};

const ChildLink = styled(Link)<ChildLinkProps>`
  border-radius: 0;
  color: ${(props) => props.theme.colors.darkGrey};
  display: flex;
  align-items: center;
  flex: flex-wrap;
  font-size: 2rem;
  pointer-events: none;
  position: relative;
  width: 100%;
  height: 100%;
  text-align: left;

  ${(props) => childLinkHandler(props.selected, props.highlighted)}
`;

export default CustomReportMenuItem;
